export function parseSnapshot(text) {
  const lines = text.split(/\r?\n/);
  // support both forms: category.index.rest=value and category.rest=value (no numeric index)
  const entryRegex = /^([a-z]+)(?:\.(\d+))?\.(.*?)=(.*)$/;
  const entries = [];
  const nameMap = {};

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const m = entryRegex.exec(line);
    if (m) {
      const category = m[1];
      const index = (typeof m[2] !== 'undefined') ? parseInt(m[2], 10) : null;
      const rest = m[3];
      const value = m[4];
      entries.push({ lineIndex: i, line, category, index, rest, value });
      if (rest === "name" && index != null) {
        nameMap[`${category}.${index}`] = value;
      }
    }
  }

  const channels = {};
  for (const e of entries) {
    // only indexed entries represent channel rows
    if (e.index == null) continue;
    channels[e.category] = channels[e.category] || new Set();
    channels[e.category].add(e.index);
  }

  const channelsArr = {};
  for (const cat of Object.keys(channels)) {
    const arr = Array.from(channels[cat])
      .sort((a, b) => a - b)
      .map((idx) => ({
        index: idx,
        name: nameMap[`${cat}.${idx}`] || "",
      }));
    channelsArr[cat] = arr;
  }

  return { lines, entries, channels: channelsArr };
}
